<template>
  <div class="decore-hire">
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top">
      <div class="grid">
        <div class="grid-left fade-in-left">
          <h1 class="page-title" data-FadeInLeft-stagger>Decor Hire</h1>
          <p data-FadeInLeft-stagger>
            To compliment our floral designs we have an extensive collection
            of decor that will enhance any occasion. We are dedicated to ensure
            that the qualities of our pieces are of a high standard. If we don’t
            have what you are looking for, give us the opportunity to source it
            for you.
          </p>
          <router-link :to="{name: 'catalogue'}" class="btn grid-left__button">
            Our Catalogue
          </router-link>
        </div>
        <div class="grid-right fade-in-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import fadeInLeftStagger from '@/mixins/staggerFadeInLeft'

export default {
  name: 'DecorHire',
  mixins: [fadeInLeftStagger],
  metaInfo: {
    title: 'Berries and Blooms - Decore Hire',
    links: [
      { rel: 'canonical', href: 'http://berriesandblooms.co.za/decor-hire' },
      { rel: 'alternate', href: 'http://berriesandblooms.co.za/decor-hire', hreflang: 'en-us' },
    ],
  },
}
</script>

<style lang="scss" scoped>
  .grid {
    background: rgba(255, 255, 255, .65);
    display: grid;
    padding: 40px 20px;

    @media(min-width: 992px) {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .10);
      grid-template-columns: 1fr 1fr;
      grid-template-areas: 'grid-left grid-right';
      padding: 0;
    }

    @media(min-width: 1336px) {
      margin: 20px 160px 0;
    }
  }

  .grid-left {
    grid-area: grid-left;

    @media(min-width: 992px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 90px
    }

    @media(min-width: 1200px) {
      padding: 50px 80px 80px;
    }

    .grid-left__button {
      align-self: flex-start;
      background-color: $brand-primary;
      border-color: transparent;
      color: white;
      display: inline-block;
      padding: 10px 20px;
    }
  }

  .grid-right {
    @media(min-width: 992px) {
      background-image: url('~@/assets/decor_hire_block.jpg');
      grid-area: grid-right;
      height: 60vh;
      background-size: cover;
      background-repeat: no-repeat;
    }

    @media(min-width: 1280px) {
      height: 100%;
    }

    @media(min-width: 1336px) {
      height: 85vh;
    }
  }

  .decore-hire {
    .page-title {
      font-family: 'great_vibesregular';
      font-size: 3.5rem;
      font-weight: 700;
      margin: 2rem 0;
      padding-bottom: 10px;
      position: relative;

      &::before {
        background: rgba($brand-primary, 1);
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 55px;
      }
    }

    p {
      font-size: 1rem;
      font-weight: 300;
      line-height: 1.8;
      margin: 10px 0 40px;

      @media(min-width: 1200px) {
        font-size: 1.2rem;
      }
    }
  }
</style>
